import { render, staticRenderFns } from "./BlwIcon.vue?vue&type=template&id=1cbc9a69&"
import script from "./BlwIcon.vue?vue&type=script&lang=js&"
export * from "./BlwIcon.vue?vue&type=script&lang=js&"
import style0 from "./BlwIcon.vue?vue&type=style&index=0&id=1cbc9a69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports